<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-logout-page">
    <div v-if="!isC1Auth">
      Logout...
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'logout',  

  computed: {
    ...mapGetters(['isC1Auth'])
  },

  created() {
    window.sessionStorage.clear();

    if(this.isAccessService) {
      setTimeout(() => {
        window.location = location.pathname;
      }, 300)
    }
    else {
      window.location = location.pathname;
    }
  }
});
</script>

<style lang="scss">
.wy-logout-page {
  padding: 40px;
  text-align: center;
}
</style>